<template>
    <div class="codics-aonaer-info-sys-news-body">
        <WebHeader></WebHeader>
        <div style="height: 100px;width: 100%;position: relative;float: left;"></div>
        <BreadCrumb></BreadCrumb>
        <div class="codics-aonaer-info-sys-news-item-box">
            <div class="codics-aonaer-info-sys-news-item" v-for="(item, index) in newsList" :key="index"
                @click="jumpToPage('新闻内容', { id: item.id }, {})">
                <el-image class="codics-aonaer-info-sys-news-item-img" :src="'https://cdn.bosscaigou.com/' + item?.himg"
                    fit="cover"></el-image>
                <div class="codics-aonaer-info-sys-news-item-content-box">
                    <div class="codics-aonaer-info-sys-news-item-title">{{ item.title }}</div>
                    <div class="codics-aonaer-info-sys-news-item-stime">{{ initTime(item.stime) }}</div>
                    <div class="codics-aonaer-info-sys-news-item-content">{{ item.content }}</div>
                    <div class="codics-aonaer-info-sys-news-item-btn" @click="jumpToPage('新闻内容', { id: item.id }, {})">
                        阅读全文</div>
                </div>
            </div>
        </div>
        <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]"
            :page-size="dataSize" layout="total, sizes, prev, pager, next, jumper" :total="maxSize">
        </el-pagination>
        <WebFooter></WebFooter>
    </div>
</template>

<script>
import WebHeader from '@/components/WebHeader';
import BreadCrumb from '@/components/BreadCrumb';
import WebFooter from '@/components/WebFooter';
import { listNews2 } from '@/api';
import dayjs from 'dayjs';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            dataSize: 10,
            currentPage: 1,
            maxSize: 0,
            newsList: []
        }
    },
    mounted() {
        this.listNewsFuc();
    },
    methods: {
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        async listNewsFuc() {

            const data = await listNews2();

            if (data.code == 200) {

                this.newsList = data.data;

                this.maxSize = data.count;

            } else {

                this.$message.error(data.message);

            }
        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
    },
    components: {
        WebHeader,
        BreadCrumb,
        WebFooter
    }
}
</script>

<style>
.codics-aonaer-info-sys-news-body {
    height: 100%;
    min-height: 100vh;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
}

.codics-aonaer-info-sys-news-item-box {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    margin-top: 40px;
    margin-bottom: 30px;
}

.codics-aonaer-info-sys-news-item {
    height: 266px;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding-bottom: 25px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
    user-select: none;
    -webkit-user-drag: none;
    margin-bottom: 25px;
}

.codics-aonaer-info-sys-news-item-img {
    height: 100%;
    width: 340px;
    position: relative;
    float: left;
}

.codics-aonaer-info-sys-news-item-content-box {
    height: 100%;
    width: calc(100% - 340px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 0 0 25px;
}

.codics-aonaer-info-sys-news-item-title {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 30px;
    font-size: 22px;
    font-weight: bolder;
    margin-bottom: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    padding-right: 100px;
}

.codics-aonaer-info-sys-news-item-stime {
    height: 24px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 24px;
    font-size: 16px;
    color: #999;
    letter-spacing: 1px;
    margin-bottom: 25px;
}

.codics-aonaer-info-sys-news-item-content {
    height: 52px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 26px;
    font-size: 16px;
    color: #555;
    margin-bottom: 30px;
}

.codics-aonaer-info-sys-news-item-btn {
    height: 40px;
    width: fit-content;
    position: relative;
    float: left;
    line-height: 40px;
    font-size: 16px;
    color: #999;
    background: #EEE;
    /* color: #FFF; */
    /* background: #ea5b18; */
    box-sizing: border-box;
    padding: 0 25px;
    border-radius: 20px;
    transition: .3s;
}

.codics-aonaer-info-sys-news-item:hover .codics-aonaer-info-sys-news-item-btn {
    color: #FFF;
    background: #ea5b18;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    left: 50%;
    margin-bottom: 50px;
    transform: translateX(-50%);
}

.codics-aonaer-info-sys-news-pagination .active {
    background-color: #ea5b18 !important;
}

@media(max-width: 768px) {
    .codics-aonaer-info-sys-news-info-nr{
        width: 100% !important;
    }
    .codics-aonaer-info-sys-news-info-last-news{
        display: none !important;
    }
    .codics-aonaer-info-sys-news-info-box{
        padding: 20px 0 !important;
    }
}
</style>